import React, {Fragment, Suspense} from 'react';
import Tabs from 'react-responsive-tabs';
import QuickReply from "../QuickReply/index";
import { useForm, Controller } from "react-hook-form";
import InteractiveMessageList from "../Settings/Whatsapp/AutoReply/Index";
import Common from "../../Common/Common";

function GetChatBot () {
    const form = useForm();
    const tabsContent = [
        {
            title: 'Chatbot',
            content: <QuickReply useForm={form} type={`auto-reply`}/>
        },
        {
            title: 'List Messages/ Reply Buttons',
            content: <InteractiveMessageList hookForm={form} controller={Controller}/>
        }
    ];
    return tabsContent;
}
function getTabs() {
    let tabsContent = GetChatBot();
    return tabsContent.map((tab, index) => ({
        title: tab.title,
        getContent: () => tab.content,
        key: index,
    }));
}


const ChatBot = props => {

    return (
        <Common pageTitle={"Chatbot"} customClass="no-padding" mainContent={
            <Fragment>
                <div className="setup-container chatbot-settings">
                    <Tabs tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding" transform={false} showInkBar={true} items={getTabs()}/>
                </div>
            </Fragment>
        } />
    )


}

export default ChatBot;
